import { useWebViewStore } from '#ui-shared/stores/webview/webview-store';
import { isWebViewMode } from '#ui-shared/utils/webview-utils';

export async function bootstrapWebviewMode(): Promise<boolean> {
  if (!isWebViewMode()) {
    return false;
  }

  console.debug('Running in webview mode');

  const webViewStore = useWebViewStore();
  await webViewStore.initiateWebView();

  return true;
}
